import ProductModel from './ProductModel';

export default ProductModel;